import { useMutation } from '@tanstack/react-query';
import { patchOpenMarketProductViewsById } from '../../../../api/product/mutations/patchOpenMarketProductViewsById';

export const usePatchOpenMarketProductViewsByIdMutation = () => {
  return useMutation(patchOpenMarketProductViewsById);
};
